import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { UnitSimModel } from '../shared/models/UnitSimModel';
import { ACTIVE, INACTIVE, CANCELLED } from '../shared/constants';
import { Configuration } from '../app.constants';
import { OidcSecurityService } from '../auth/services/oidc.security.service';


@Injectable()
export class TrafficService {

    private actionUrl: string;
    private headers: Headers;
    private uData: any;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/Active/`;
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public Get = (unitId: string, unitType: string): Observable<UnitSimModel> => {
        this.setHeaders();
        this.setUri(unitType);
        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl + unitId, options).map(res => res.json());
    }

    private setUri(unitType: string): void {
        switch (unitType) {
            case ACTIVE:
                this.actionUrl = `${this._configuration.Server}api/Active/`;
                break;
            case INACTIVE:
                this.actionUrl = `${this._configuration.Server}api/Inactive/`;
                break;
            case CANCELLED:
                this.actionUrl = `${this._configuration.Server}api/Cancelled/`;
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/traffic/traffic.service.ts